import { IMttUrlService } from 'shared/services/interface'
import { Locale } from 'shared/i18n/interface'
import config from 'config'

import { AbstractService } from 'shared/services/AbstractService'
import getLogger from 'shared/logger'
import type { MTT } from 'shared/types/vp/mtt'

export class MttUrlService extends AbstractService implements IMttUrlService {
  /**
   * Request a localized URL given urlId from the MTT URL Service
   * @param locale
   * @param urlId
   */
  public async getSpecificUrl(locale: Locale, urlId: string): Promise<string> {
    const url = `v3/url/${config.tenant}/${locale}/${urlId}`

    try {
      const { data } = await this.api.get<MTT.Url>(url, {
        params: {
          requestor: config.appName,
        },
      })

      return data.url
    } catch {
      return ''
    }
  }
}

export const UrlService = new MttUrlService(config.services.mttUrlService, getLogger)
